import { Modal } from "@circle-react-uikit/ModalV2";
import { useEffect } from "react";

import type { PlanTiers } from "@/react/helpers/planHelpers";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";

import { PlansManagement } from "../../SettingsApp/Plan/PlanSettings/experiment/PlansManagement";
import { PlansProvider } from "../../SettingsApp/Plan/RegularPlan/PlansContext";

export interface PlansModalProps {
  source?: string;
  tierDescriptions?: Partial<Record<PlanTiers, string>>;
}

export const PlansModalBody = ({
  source,
  tierDescriptions,
}: PlansModalProps) => {
  const { trackEvent } = useEventsTracker();

  useEffect(() => {
    trackEvent("plan_settings.plans_modal.opened", {});
  }, [trackEvent]);

  return (
    <Modal.Body className="scrollbar-hide">
      <PlansProvider source={source} tierDescriptions={tierDescriptions}>
        <div className="mx-auto max-w-[1080px]">
          <PlansManagement />
        </div>
      </PlansProvider>
    </Modal.Body>
  );
};
